import { Component, OnInit } from '@angular/core';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { RouterOutlet } from '@angular/router';
import { MenuItem, MenuItemCommandEvent, SharedModule } from 'primeng/api';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { NgIf } from '@angular/common';
import { PermissionService } from '../../../services/permission.service';

@Component({
  selector: 'app-object-adder',
  standalone: true,
  imports: [RouterOutlet, SharedModule, MenuModule, PanelMenuModule, NgIf],
  templateUrl: './entity-adder.component.html',
  styleUrl: './entity-adder.component.scss',
})
export class EntityAdderComponent implements OnInit {
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-30rem',
    icon: 'fas fa-plus',
    headerText: 'Neu hinzufügen',
  };
  items: MenuItem[] | undefined;
  expanded = false;

  constructor(
    private sidebarService: SidebarService,
    private permissionService: PermissionService
  ) {}

  /**
   * Initializes the component by setting up the sidebar configuration, expanding the overlay,
   * and creating a list of menu items with dynamic visibility based on user permissions.
   *
   * @return {void} No return value.
   */
  ngOnInit(): void {
    this.sidebarService.setConfiguration(this.sidebarConfig);
    this.expandOverlay(); // todo

    this.items = [
      {
        visible:
          this.permissionService.hasAddRightsByEntityType('dataLayerType'),
        label: 'Raum',
        icon: 'fa-regular fa-map',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['raum', 'neu'] } }],
      },
      {
        visible:
          this.permissionService.hasAddRightsByEntityType('poiDataLayerType'),
        label: 'Standorte',
        icon: 'fas fa-location-dot',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['poi', 'neu'] } }],
      },
      {
        visible:
          this.permissionService.hasAddRightsByEntityType('dataLayerType') ||
          this.permissionService.hasAddRightsByEntityType('poiDataLayerType'),
        label: 'Jahr',
        icon: 'fas fa-calendar-days',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['jahr', 'neu'] } }],
      },
      {
        visible:
          this.permissionService.hasAddRightsByEntityType('indicatorCategory'),
        label: 'Indikatorenordner',
        icon: 'fas fa-folder',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['indikatoren-bereich', 'neu'] } }],
      },
      {
        visible:
          this.permissionService.hasAddRightsByEntityType('indicatorCategory'),
        label: 'Indikator',
        icon: 'fas fa-ruler-vertical',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['indikator', 'neu', 'general'] } }],
      },
      {
        visible: this.permissionService.hasAddRightsByEntityType('topic'),
        label: 'Thema',
        icon: 'fas fa-book-open',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['thema', 'neu', 'general'] } }],
      },
      {
        visible:
          this.permissionService.hasAddRightsByEntityType('bookmarkCategory'),
        label: 'Ansicht',
        icon: 'fas fa-note-sticky',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['lesezeichen', 'neu'] } }],
      },
      {
        visible:
          this.permissionService.hasAddRightsByEntityType('bookmarkCategory'),
        label: 'Themenbereich',
        icon: 'fas fa-layer-group',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['lesezeichenbereich', 'neu'] } }],
      },
      {
        visible: this.permissionService.canActivate('colorsets', false),
        label: 'Farbset',
        icon: 'fas fa-palette',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['farbset', 'neu'] } }],
      },
      {
        visible: this.permissionService.canActivate('config', false),
        label: 'Schlagwort',
        icon: 'fas fa-tag',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['schlagwort', 'neu'] } }],
      },
      {
        visible: this.permissionService.canActivate('config', false),
        label: 'Vergleichswert',
        icon: 'fas fa-scale-unbalanced-flip',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['vergleichswert', 'neu'] } }],
      },
      {
        visible: this.permissionService.canActivate('userManagement', false),
        label: 'Arbeitsbereich',
        icon: 'fas fa-users-viewfinder',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['workspace', 'neu'] } }],
      },
      {
        visible: this.permissionService.canActivate('userManagement', false),
        label: 'Rolle',
        icon: 'fas fa-user-shield',
        command: () => {
          this.expandOverlay();
        },
        routerLink: [{ outlets: { panel: ['rolle', 'neu'] } }],
      },
    ];
  }

  /**
   * Expands the overlay by setting the sidebar configuration to full-screen width and updating the expanded state.
   *
   * @return {void} This method does not return a value.
   */
  expandOverlay(): void {
    this.sidebarConfig.cssClasses = 'w-screen';
    this.sidebarService.setConfiguration(this.sidebarConfig);
    this.expanded = true;
  }
}
